function KataList2Entry(){
     return(
           <div>  
             <h2>KataList2Entry</h2>
             <p>details here</p>
            </div>
         );
}
export default KataList2Entry;